<!--  -->
<template>
  <div class="">
    <left-conduit
      ref="aaaa"
      style="z-index:3"
      class="oneConduit"
      :conduitInfo="lineInfoLeft0_1"
    ></left-conduit>
    <left-conduit
      ref="aaaa"
      style="z-index:3"
      class="oneConduit"
      :conduitInfo="lineInfoLeft0_2"
    ></left-conduit>
    <left-conduit
      ref="aaaa"
      style="z-index:3"
      class="oneConduit"
      :conduitInfo="lineInfoRight0_1"
    ></left-conduit>
    <left-conduit
      ref="aaaa"
      style="z-index:3"
      class="oneConduit"
      :conduitInfo="lineInfoRight0_2"
    ></left-conduit>
    <left-conduit
      ref="aaaa"
      style="z-index:3"
      class="oneConduit"
      :conduitInfo="lineInfoLeft1_1"
    ></left-conduit>
     <left-conduit
      ref="aaaa"
      style="z-index:3"
      class="oneConduit"
      :conduitInfo="lineInfoLeft1_2"
    ></left-conduit>
      <left-conduit
      ref="aaaa"
      style="z-index:3"
      class="oneConduit"
      :conduitInfo="lineInfoRight1_1"
    ></left-conduit>
      <left-conduit
      ref="aaaa"
      style="z-index:3"
      class="oneConduit"
      :conduitInfo="lineInfoRight1_2"
    ></left-conduit>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import leftConduit from '@/components/leftConduit.vue';
import { lineArr } from './const';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: { leftConduit },
  data() {
    // 这里存放数据
    return {
      lineArr,
      lineInfoLeft0_1: {
        id: 'left0_1',
        colors: ['rgba(41,104,237,0.15)'], // 渐变
        // colors: ['transparent'], // 渐变
        colorsLevel: [1],
        LinearGradient: {
          // 设置管道渐变起终点
          x0: 0,
          y0: 390,
          x1: 720,
          y1: 0,
        },
        canvasWidth: 10, // 宽度
        canvasHeight: 20, // 高度
        step: 2, // 运动速度
        space: 150, // 光标的间隔
        curterlength: 80, // 光标长度
        curterWidth: 2, // 光标宽度
        curveLineWidth: 2, // 管道宽度
        shadowOpcity: '0.6',
        stop: false,
        // shadowColor: 'rgba(41,104,237,0.4)',
        shadowColor: '85,145,250',
        // shadowColor: '255,255,255',
        // shadowColor: 'transparent',
        points: [
          // 整体路径
          {
            // 起始点
            x: 468,
            y: 283,
          },
          {
            // 中点
            x: 520,
            y: 283,
          },
          {
            // 转折点
            x: 564,
            y: 428,
          },
          {
            // 转折点
            x: 650,
            y: 428,
          },
        ],
      },
      lineInfoLeft0_2: {
        id: 'left0_2',
        circlePoint: {
          // 空心圆位置
          x: 866,
          y: 468,
        },
        circleRadius: 5, // 终点空心圆半径
        circleLineWidth: 2, // 终点空心圆线路宽度
        circleColor: 'rgba(41,104,237,0.7)', // 空心圆颜色
        colors: ['rgba(41,104,237,0.15)'], // 渐变
        colorsLevel: [1],
        LinearGradient: {
          // 设置管道渐变起终点
          x0: 0,
          y0: 390,
          x1: 720,
          y1: 0,
        },
        canvasWidth: 10, // 宽度
        canvasHeight: 20, // 高度
        step: 1, // 运动速度
        space: 200, // 光标的间隔
        curterlength: 30, // 光标长度
        curterWidth: 2, // 光标宽度
        curveLineWidth: 2, // 管道宽度
        shadowOpcity: '0.6',
        stop: false,
        shadowColor: '85,145,250',
        // shadowColor: 'transparent',
        points: [
          // 整体路径
          {
            // 起始点
            x: 794,
            y: 428,
          },
          {
            // 转折点
            x: 820,
            y: 428,
          },
          {
            // 转折点
            x: 844,
            y: 468,
          },
          {
            // 转折点
            x: 862,
            y: 468,
          },
        ],
      },
      lineInfoRight0_1: {
        id: 'right0_1',
        colors: ['rgba(41,104,237,0.15)'], // 渐变
        colorsLevel: [1],
        LinearGradient: {
          // 设置管道渐变起终点
          x0: 0,
          y0: 390,
          x1: 720,
          y1: 0,
        },
        canvasWidth: 10, // 宽度
        canvasHeight: 20, // 高度
        step: 2, // 运动速度
        space: 150, // 光标的间隔
        curterlength: 80, // 光标长度
        curterWidth: 2, // 光标宽度
        curveLineWidth: 2, // 管道宽度
        shadowOpcity: '0.6',
        stop: false,
        shadowColor: '85,145,250',
        // shadowColor: 'transparent',
        points: [
          // 整体路径
          {
            // 起始点
            x: 1452,
            y: 283,
          },
          {
            // 中点
            x: 1400,
            y: 283,
          },
          {
            // 转折点
            x: 1396,
            y: 283,
          },
          {
            // 转折点
            x: 1356,
            y: 428,
          },
          {
            // 转折点
            x: 1278,
            y: 428,
          },
        ],
      },
      lineInfoRight0_2: {
        id: 'right0_2',
        circlePoint: {
          // 空心圆位置
          x: 1054,
          y: 468,
        },

        circleRadius: 5, // 终点空心圆半径
        circleLineWidth: 2, // 终点空心圆线路宽度
        circleColor: 'rgba(41,104,237,0.7)', // 空心圆颜色
        colors: ['rgba(41,104,237,0.15)'], // 渐变
        colorsLevel: [1],
        LinearGradient: {
          // 设置管道渐变起终点
          x0: 0,
          y0: 390,
          x1: 720,
          y1: 0,
        },
        canvasWidth: 10, // 宽度
        canvasHeight: 20, // 高度
        step: 1, // 运动速度
        space: 200, // 光标的间隔
        curterlength: 30, // 光标长度
        curterWidth: 2, // 光标宽度
        curveLineWidth: 2, // 管道宽度
        shadowOpcity: '0.6',
        stop: false,
        shadowColor: '85,145,250',
        // shadowColor: 'transparent',
        points: [
          // 整体路径
          {
            // 起始点
            x: 1135,
            y: 428,
          },
          {
            // 转折点
            x: 1105,
            y: 428,
          },
          {
            // 转折点
            x: 1080,
            y: 468,
          },
          {
            // 转折点
            x: 1058,
            y: 468,
          },
        ],
      },
      lineInfoLeft1_1: {
        id: 'left1_1',
        colors: ['rgba(41,104,237,0.15)'], // 渐变
        colorsLevel: [1],
        LinearGradient: {
          // 设置管道渐变起终点
          x0: 0,
          y0: 390,
          x1: 720,
          y1: 0,
        },
        canvasWidth: 10, // 宽度
        canvasHeight: 20, // 高度
        step: 2, // 运动速度
        space: 150, // 光标的间隔
        curterlength: 80, // 光标长度
        curterWidth: 2, // 光标宽度
        curveLineWidth: 2, // 管道宽度
        shadowOpcity: '0.6',
        stop: false,
        shadowColor: '85,145,250',
        // shadowColor: 'transparent',
        points: [
          // 整体路径
          {
            // 起始点
            x: 523,
            y: 578,
          },
          {
            // 起始点
            x: 526,
            y: 578,
          },
          {
            // 转折点
            x: 550,
            y: 578,
          },
          // {
          //   // 起始点
          //   x: 523,
          //   y: 590,
          // },
          // {
          //   // 起始点
          //   x: 526,
          //   y: 590,
          // },
          // {
          //   // 转折点
          //   x: 550,
          //   y: 590,
          // },
          {
            // 转折点
            x: 564,
            y: 650,
          },
          {
            // 转折点
            x: 629,
            y: 650,
          },
        ],
      },
      lineInfoLeft1_2: {
        id: 'left1_2',
        circlePoint: {
          // 空心圆位置
          x: 874,
          y: 590,
        },
        circleRadius: 5, // 终点空心圆半径
        circleLineWidth: 2, // 终点空心圆线路宽度
        circleColor: 'rgba(41,104,237,0.7)', // 空心圆颜色
        colors: ['rgba(41,104,237,0.15)'], // 渐变
        colorsLevel: [1],
        LinearGradient: {
          // 设置管道渐变起终点
          x0: 0,
          y0: 390,
          x1: 720,
          y1: 0,
        },
        canvasWidth: 10, // 宽度
        canvasHeight: 20, // 高度
        step: 1, // 运动速度
        space: 200, // 光标的间隔
        curterlength: 30, // 光标长度
        curterWidth: 2, // 光标宽度
        curveLineWidth: 2, // 管道宽度
        shadowOpcity: '0.6',
        stop: false,
        shadowColor: '85,145,250',
        // shadowColor: 'transparent',
        points: [
          // 整体路径
          {
            // 起始点
            x: 772,
            y: 650,
          },
          {
            // 转折点
            x: 800,
            y: 650,
          },
          {
            // 转折点
            x: 824,
            y: 590,
          },
          {
            // 转折点
            x: 870,
            y: 590,
          },
        ],
      },
      lineInfoRight1_1: {
        id: 'right1_1',
        colors: ['rgba(41,104,237,0.15)'], // 渐变
        colorsLevel: [1],
        LinearGradient: {
          // 设置管道渐变起终点
          x0: 0,
          y0: 390,
          x1: 720,
          y1: 0,
        },
        canvasWidth: 10, // 宽度
        canvasHeight: 20, // 高度
        step: 2, // 运动速度
        space: 150, // 光标的间隔
        curterlength: 80, // 光标长度
        curterWidth: 2, // 光标宽度
        curveLineWidth: 2, // 管道宽度
        shadowOpcity: '0.6',
        stop: false,
        shadowColor: '85,145,250',
        // shadowColor: 'transparent',
        points: [
          // 整体路径
          // {
          //   // 起始点
          //   x: 1402,
          //   y: 590,
          // },
          // {
          //   // 转折点
          //   x: 1375,
          //   y: 590,
          // },
          {
            // 起始点
            x: 1402,
            y: 578,
          },
          {
            // 转折点
            x: 1375,
            y: 578,
          },
          {
            // 转折点
            x: 1361,
            y: 650,
          },
          {
            // 转折点
            x: 1296,
            y: 650,
          },
        ],
      },
      lineInfoRight1_2: {
        id: 'right1_2',
        circlePoint: {
          // 空心圆位置
          x: 1043,
          y: 590,
        },
        circleRadius: 5, // 终点空心圆半径
        circleLineWidth: 2, // 终点空心圆线路宽度
        circleColor: 'rgba(41,104,237,0.7)', // 空心圆颜色
        colors: ['rgba(41,104,237,0.15)'], // 渐变
        colorsLevel: [1],
        LinearGradient: {
          // 设置管道渐变起终点
          x0: 0,
          y0: 390,
          x1: 720,
          y1: 0,
        },
        canvasWidth: 10, // 宽度
        canvasHeight: 20, // 高度
        step: 1, // 运动速度
        space: 200, // 光标的间隔
        curterlength: 30, // 光标长度
        curterWidth: 2, // 光标宽度
        curveLineWidth: 2, // 管道宽度
        shadowOpcity: '0.6',
        stop: false,
        shadowColor: '85,145,250',
        // shadowColor: 'transparent',
        points: [
          // 整体路径
          {
            // 转折点
            x: 1152,
            y: 650,
          },
          {
            // 转折点
            x: 1125,
            y: 650,
          },
          {
            // 转折点
            x: 1090,
            y: 590,
          },
          {
            // 转折点
            x: 1047,
            y: 590,
          },
        ],
      },
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // reset() {
    //   Object.keys(lineArr).map((item) => {
    //     this[item].colors = lineArr[item].colors;
    //     this[item].colorsLevel = lineArr[item].colorsLevel;
    //     this[item].step = lineArr[item].step;
    //     this[item].curterlength = lineArr[item].curterlength;
    //     this[item].space = lineArr[item].space;
    //     this[item].stop = lineArr[item].stop;
    //   });
    //   this.lineInfoLeft3.points.map((item) => {
    //     if (item.isStart === false) {
    //       item.isStart = true;
    //     }
    //     if (item.isEnd === false) {
    //       item.isEnd = true;
    //     }
    //   });
    // },
    // setColor() {
    //   this.lineInfoLeft3.points.map((item) => {
    //     if (item.isStart === true) {
    //       item.isStart = false;
    //     }
    //     if (item.isEnd === true) {
    //       item.isEnd = false;
    //     }
    //   });
    //   this.lineInfoLeft0.space = 60;
    //   this.lineInfoLeft1.space = 60;
    //   this.lineInfoLeft2.space = 150;
    //   this.lineInfoLeft3.space = 57;
    //   this.lineInfoLeft4.space = 60;
    //   for (let index = 0; index <= 4; index++) {
    //     this[`lineInfoLeft${index}`].colors = ['#FF9C38', '#FFC967', '#FFC967'];
    //     this[`lineInfoLeft${index}`].colorsLevel = [0, 0.5, 1];
    //     this[`lineInfoLeft${index}`].step = 10;
    //     this[`lineInfoLeft${index}`].curterlength = 20;
    //   }
    //   for (let index = 0; index < 15; index++) {
    //     this[`lineInfoLeft_${index}`].stop = true;
    //     this[`lineInfoLeft_${index}`].step = 1.3;
    //   }
    // },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类

.oneConduit {
  position: absolute;
  left: 0;
  top: 0;
  right:0;
  bottom:0;
}

</style>
